import { render, staticRenderFns } from "./comprarServicio.vue?vue&type=template&id=29554859&scoped=true&"
import script from "./comprarServicio.vue?vue&type=script&lang=js&"
export * from "./comprarServicio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29554859",
  null
  
)

export default component.exports